module.exports = __webpack_public_path__ + "img/indu_9.12db11f3.png";